import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConveyorScrewClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 220,
	height: 80,
	viewBox: "0 0 220.0 80.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 10,
		y: 0,
		width: 210,
		height: 80,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 35.0 40.0 L 50.0 15.0 L 80.0 65.0 L 95.0 40.0 M 0.0 40.0 L 205.0 40.0 M 130.0 40.0 L 145.0 15.0 L 175.0 65.0 L 190.0 40.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgConveyorScrewClosed;
